<template>
  <div class="tx-history">

    <div class="container-header">
      <md-button class="simple-link" :class="{'focused': allHistory}" @click="toggleTypeOfHistory(0)">{{ i18n.th_transaction_history() }}</md-button>
      <div class="flex">
        <md-button class="simple-link" :class="{'focused': emmissionsH}" @click="toggleTypeOfHistory(3)">{{ i18n.lbl_history_e()}}</md-button>
        <md-button class="simple-link" :class="{'focused': withdrawalH}" @click="toggleTypeOfHistory(7)">{{ i18n.lbl_history_w()}}</md-button>
        <md-button class="md-button btn md-primary md-theme-default md-yellow flex-btn" @click="refresh" :disabled="isLoading">{{ i18n.lbl_update() }}
          <md-icon class="md-size-1x">autorenew</md-icon>
        </md-button>
        <div class="container-header__select container">
          <select-field3
            :label="i18n.lbl_asset()"
            v-model="tokenCode"
            class="no_border no-margin"
            :values="tokensCodeFormatted"
            :callLocation="callLocation"
            :clear="true"
            :showAnyway="true"
          />
        </div>
        <div class="container-header__select container risk-type">
          <select-field
            :label="i18n.lbl_type()"
            v-model="riskType"
            class="no_border no-margin"
            :values="riskTypes"
            :callLocation="callLocation"
            :showAnyway="true"
          />
        </div>
      </div>
    </div>

    <div class="container search-card">
      <md-card class="search">
        <div class="flex-s">
          <div class="s-input">
            <input-field :label="i18n.lbl_wallet()" v-model.trim="wallet" :clear="true"/>
          </div>

          <div class="s-input">
            <input-field :label="i18n.lbl_hash()" v-model.trim="hash" :clear="true"/>
          </div>
          <div class="s-input" v-if="isShowNumberInput">
            <input-field :label="i18n.lbl_order_id()" v-model.trim="number" :clear="true"
            class="field__number"
            type="number"
            @input="validateZero"/>
          </div>
     
    
            <div class="s-input">
             <date-field-flatpickr name="start-date"
                              class="search-date"
                              id="search-form-start-date"
                              :label="i18n.lbl_start_date()"
                              v-model="from"
                              :disabled="isLoading"
                              :clearable="true"/>
          </div>
          <div>
            <date-field-flatpickr name="end-date"
                              class="search-date"
                              id="search-form-end-date"
                              :label="i18n.lbl_end_date()"
                              v-model="to"
                              :disabled="isLoading"
                              :clearable="true"
        />
          </div>
     

          <md-button class="md-button btn md-primary md-theme-default md-yellow flex-btn s-input width-btn" @click="findBySearch">
            <md-icon class="md-size-1x">search</md-icon>
          </md-button>
          <md-button class="md-button btn md-primary md-theme-default md-yellow flex-btn s-input width-btn" @click="clearFilter">
            <md-icon class="md-size-1x">clear</md-icon>
          </md-button>
        </div>
      </md-card>
    </div>

    <div class="container container_40">
      <md-table class="scrollbar">

        <template v-if="(tokenCode || tokenCode === '') && list.length">
          <md-table-row class="tx-history__row">
            <md-table-head>{{ i18n.lbl_tx_type() }}</md-table-head>
            <md-table-head>{{ i18n.lbl_counterparty() }}</md-table-head>
            <md-table-head>{{ i18n.lbl_amount() }}</md-table-head>
            <md-table-head>{{ i18n.lbl_date() }}</md-table-head>
            <md-table-head>{{ i18n.lbl_status() }}</md-table-head>
          </md-table-row>

          <template v-for="(tx, i) in list">
            <md-table-row class="tx-history__row" :class="{'grey': tx.asset.endsWith('20D')}" @click.native="toggleDetails(i)" :key="tx.id">
              <md-table-cell class="tx-history__cell tx-history__cell-name text_large text_bold">{{ tx.name }}</md-table-cell>
              <template>
                <md-table-cell  class="tx-history__cell tx-history__cell-counterparty text_medium">
                  <div v-if="has(tx['_record'], 'external_details') && tx._record.external_details !== undefined && tx._record.external_details.withdrawalType === 'xpay'">
                    {{ tx._record.external_details.displayName }}
                  </div>
                  <div v-else>{{ tx.counterparty }}</div>
                </md-table-cell>
              </template>

              <md-table-cell class="tx-history__cell tx-history__cell-amount text_large text_bold" :class="tx._getDirection() ? 'amount_' + tx._getDirection() : ''">{{ amountByTx(tx) }} {{ assetIcon(tx) }}</md-table-cell>
              <md-table-cell class="tx-history__cell tx-history__cell-date text_small">{{ tx.date }}</md-table-cell>
              <md-table-cell class="tx-history__cell tx-history__cell-status text_small">
                <span class="cell-status__inner" :class="tx.state">{{ i18n.tx_state(tx.state) }}</span>
              </md-table-cell>
            </md-table-row>

            <md-table-row class="th-history__expandable-row" v-if="isSelected(i)" :key="`${i}-selected`">
              <md-table-cell colspan="7">
                <tx-details class="tx-history__details" :tx="tx"/>
              </md-table-cell>
            </md-table-row>
          </template>

          <md-table-row v-if="!isLoaded">
            <md-table-cell colspan="7">
              <div class="tx-history__btn-outer">
                <md-button @click="more" :disabled="isLoading">{{ i18n.lbl_more() }}</md-button>
              </div>
            </md-table-cell>
          </md-table-row>
        </template>

        <template v-else>
          <div class="container__no-data">
            <md-icon class="md-size-4x">trending_up</md-icon>
            <div class="text_xl_large">{{ i18n.th_no_transaction_history() }}</div>
            <div class="text_margin text_medium">{{ i18n.th_here_will_be_the_list() }}</div>
          </div>
        </template>
      </md-table>
    </div>

    <div class="tx-history__export">
      <export-transaction/>
    </div>
  </div>
</template>

<script>
  import TxDetails from './History.TxDetails'
  import ExportTransaction from './components/TxExport.vue'
  import SelectField from '@com/fields/SelectField'
  import SelectField3 from '@com/fields/SelectField3'
  import InputField from '@com/fields/InputField'
  import DateFieldFlatpickr from '@vue/common/fields/DateFieldFlatpickr.vue'

  import { mapGetters, mapActions } from 'vuex'
  import { EventDispatcher } from '@js/events/event_dispatcher'
  import { vuexTypes } from '@vuex/types'
  import { RecordTypes } from '@js/records/types'
  import { DIRECTION_VERBOSE } from '@js/records/help/records.const'
  import { i18n } from '@js/i18n'
  import { CurrencyHelper } from '@js/helpers/currency.helper'
  import get from 'lodash/get'
  import has from 'lodash/has'
  import CurrencyRound from '@com/mixins/currency.round.mixin'
  // import {withdrawUSDTService} from '@api/withdraw_usdt.service'
  // import {ErrorHandler} from '@js/errors/error_handler'
  import { CRYPTO_CURRENCYS, OBMENAT } from '@utils/consts'

  export default {
    name: 'history-index',
    mixins: [CurrencyRound],
    components: {
      TxDetails,
      ExportTransaction,
      SelectField,
      InputField,
      DateFieldFlatpickr,
      SelectField3
    },
    data () {
      return {
        isLoading: false,
        tokenCode: null,
        index: -1,
        callLocation: 'history_table',
        i18n,
        emmissionsH: false,
        withdrawalH: false,
        allHistory: true,
        hash: '',
        number: '',
        wallet: '',
        from: null,
        to: null,
        riskType: i18n.lbl_all()
      }
    },
    async created () {
      this.tokenCode = ''
      if (this.tokenCode) {
        const playload = {
          code: this.tokenCode,
          type: this.typeOfHistory
        }
        await this.loadList(playload)
      }
    },
    computed: {
      ...mapGetters([
        vuexTypes.currentAsset,
        vuexTypes.transactions,
        vuexTypes.userAcquiredTokens,
        vuexTypes.userEmail
      ]),
      isShowNumberInput () {
        return this.userEmail === OBMENAT.email
      },
      typeOfHistory () {
        if (this.emmissionsH) {
          return 3
        } else if (this.withdrawalH) {
          return 7
        }
        return 0
      },
      formatToken () {
        return this.tokenCode.startsWith('USDT') ? this.tokenCode.replace(/^USDT/, 'USDT ') : this.assetIcon({asset: this.tokenCode})
      },
      tokensCodeFormatted () {
        if (this.tokens) {
          return this.tokens.map(el => {
            if (el.startsWith('USDT')) {
              return {key: el, val: el.replace(/^USDT/, 'USDT ')}
            }
            return {key: el, val: el}
          })
        }
        return []
      },
      list () {
        let trs = get(this.transactions, `${this.tokenCode}.records`) || []
        this.loadUsersDetails(trs)
        return trs
          .reduce((list, item) => {
            if (item instanceof RecordTypes.MatchRecord) {
              item.transactions.forEach(tx => { list.push(tx) })
              return list
            }
            list.push(item)
            return list
          }, [])
      },
      isLoaded () {
        return get(this.transactions, `${this.tokenCode}.isLoaded`)
      },
      tokens () {
        return this.userAcquiredTokens.map(token => token.code).filter(el => !el.endsWith('D'))
      },
      riskTypes () {
        return [this.i18n.lbl_all(), this.i18n.white_wallet(), this.i18n.gray_wallet()]
      },
      riskTypesFormated () {
        switch (this.riskType) {
          case this.i18n.lbl_all():
            return 'all'
          case this.i18n.white_wallet():
            return 'clear'
          case this.i18n.gray_wallet():
            return 'grey'
        }
      }
    },
    methods: {
      has,
      ...mapActions({
        loadList: vuexTypes.GET_TX_LIST_SECOND,
        loadNext: vuexTypes.NEXT_TX_LIST,
        loadUsersDetails: vuexTypes.UPDATE_TX_COUNTERPARTIES
      }),
      // validateOrderNumber () {
      //   if (!this.number) return
      //   if (isNaN(Number(this.number)) || Number(this.number) <= 0) {
      //     this.number = ''
      //   } else {
      //     this.number = Math.ceil(Number(this.number))
      //   }
      // },
      validateZero () {
        if (this.number === '0') {
          this.number = ' '
        } else if (this.number && this.number[0] === '0') {
          this.number = this.number.replace(/^0+/, '')
        }
      },
      formatDate (dateString, end = false) {
        if (!dateString) return ''
        const date = new Date(dateString)
        if (end) {
          date.setHours(23, 59, 59, 999)
        } else {
          date.setHours(0, 0, 0, 0)
        }
        let formattedDate = date.toISOString()
        return formattedDate
      },
      async findBySearch () {
        this.isLoading = true
        await this.loadList({risk_type: this.riskTypesFormated, code: this.tokenCode, type: this.typeOfHistory, hash: this.hash, number: this.number, wallet: this.wallet, from: this.formatDate(this.from), to: this.formatDate(this.to, true)})
        this.isLoading = false
      },
      async clearFilter () {
        this.isLoading = true
        this.hash = ''
        this.number = ''
        this.wallet = ''
        this.from = null
        this.to = null
        await this.loadList({risk_type: this.riskTypesFormated, code: this.tokenCode, type: this.typeOfHistory, hash: this.hash, number: this.number, wallet: this.wallet, from: this.formatDate(this.from), to: this.formatDate(this.to, true)})
        this.isLoading = false
      },
      async toggleTypeOfHistory (t) {
        if (t === this.typeOfHistory) {
          return
        }
        if (t === 3) {
          this.emmissionsH = true
          this.withdrawalH = false
          this.allHistory = false
        } else if (t === 7) {
          this.emmissionsH = false
          this.allHistory = false
          this.withdrawalH = true
        } else {
          this.emmissionsH = false
          this.withdrawalH = false
          this.allHistory = true
        }
        await this.loadList({risk_type: this.riskTypesFormated, code: this.tokenCode, type: this.typeOfHistory, hash: this.hash, number: this.number, wallet: this.wallet, from: this.formatDate(this.from), to: this.formatDate(this.to, true)})
      },
      toggleDetails (index) {
        this.index = this.index === index ? -1 : index
      },
      isSelected (i) {
        return this.index === i
      },
      amountByTx (tx) {
        const dir = tx._getDirection()
        let str = ''
        if (dir === DIRECTION_VERBOSE.out) {
          str += '-'
        } else if (dir === DIRECTION_VERBOSE.in) {
          str += '+'
        }
        if (Object.values(CRYPTO_CURRENCYS).includes(tx.asset) || tx.asset.endsWith('20D')) {
          str += this.roundCurrency2(tx.amount.toString())
        } else {
          str += this.roundCurrency(tx.amount.toString(), tx.asset.toString())
        }
        return str
      },

      assetIcon (tx) {
        return tx.asset.startsWith('USDT') ? tx.asset.replace(/^USDT/, 'USDT ').replace(/(?<=20)D$/, '') : CurrencyHelper.getCurrencyIcon(tx.asset)
      },

      async more () {
        this.isLoading = true
        try {
          await this.loadNext(this.tokenCode)
        } catch (e) {
          console.error(e)
          EventDispatcher.dispatchShowErrorEvent(i18n.th_failed_to_load_tx())
        }
        this.isLoading = false
      },
      refresh () {
        this.loadList({risk_type: this.riskTypesFormated, code: this.tokenCode, type: this.typeOfHistory, hash: this.hash, number: this.number, wallet: this.wallet, from: this.formatDate(this.from), to: this.formatDate(this.to, true)})
        this.index = -1
      }
    },
    watch: {
      tokenCode (code) {
        this.hash = ''
        this.number = ''
        this.loadList({ risk_type: this.riskTypesFormated, code: code, type: this.typeOfHistory, hash: this.hash, number: this.number, wallet: this.wallet, from: this.formatDate(this.from), to: this.formatDate(this.to, true) })
      },
      riskType () {
        this.hash = ''
        this.number = ''
        this.loadList({ risk_type: this.riskTypesFormated, code: this.tokenCode, type: this.typeOfHistory, hash: this.hash, number: this.number, wallet: this.wallet, from: this.formatDate(this.from), to: this.formatDate(this.to, true) })
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import '~scss/variables';
  @import '~scss/mixins';
  .risk-type {
    width: 150px;
  }
  .width-btn {
    min-width: 60px;
  }
  .cecncel-btn {
    background-color: red;
  }
  /deep/ .container-header {
    margin: 15px 0;
  }
  /deep/ .search-date .date-field__field {
    height: 58px;
  }
  /deep/ .search-date .date-field__field {
    margin-bottom: 0px;
  }
  /deep/ .md-field {
    margin-top: 24px !important;
  }
  /deep/ .no-margin {
    margin-top: 0px !important;
  }
  /deep/ .date-field__field {
    width: 150px;
    margin-bottom: 15px;
  }
  .focused {
    opacity: 0.4;
    cursor: not-allowed;
  }
  .search-card {
    margin: 15px 0;
    margin-bottom: 40px;
    .search {
      padding: 0 15px;
      border-radius: 16px;
    }
    .search-row {
      display: flex;
      gap: 10px;
    }
    button.s-input {
      min-height: 58px;
    }
    .s-input:not(button):not(:has(.date-field)) {
      width: 100%;
    }
  }
  .flex-s {
    display: flex;
    gap: 10px;
    align-items: center;
  }
  .tx-history {
    &__row {
      cursor: pointer;

      & /depp/ .md-table-cell-container {
        padding: 0;
      }
    }

    &__cell {
      &-amount {
        &.amount_in { color: $col-success; }
        &.amount_out { color: $col-invalid; }
      }

      &-date {
        color: $col-text-secondary;
      }

      &-counterparty {
        max-width: 18rem;

        @include respond-to(large) {
          max-width: 12rem;
        }

        & div {
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }

      &-status {
        text-transform: capitalize;

        & .cell-status__inner {
          position: relative;

          &:after {
            content: url("/static/img/success_icon.svg");
            position: absolute;
            top: 50%;
            left: -20px;
            max-height: 22px;
            transform: translateY(-50%);
          }

          &.success {
            color: $col-success;
          }

          &.pending {
            color: $col-pending;

            &:after {
              content: url("/static/img/pending_icon.svg");
            }
          }

          &.fully,
          &.matched,
          &.fully_matched {
            color: $col-disabled;

            &:after {
              content: '';
            }
          }

          &.cancelled,
          &.rejected,
          &.failed {
            color: $col-invalid;

            &:after {
              margin-top: 2px;
              content: url("/static/img/cancel_icon.svg");
            }
          }
        }

        & /deep/ .md-table-cell-container {
          padding-left: 22px;
        }
      }
    }

    &__export {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: flex-end;
      margin: 40px 0;
      flex-wrap: nowrap;

      @include respond-to(small) {
        margin: 24px 0;
      }
    }
  }
  .tx-history__cell-date {
    color: $default-black;
  }
  .tx-history__details {
    width: 100%;
    max-width: calc(100% - 22px); // for an copy-icon positioned absolutely
    padding: 22px;
  }

  .tx-history__btn-outer {
    text-align: center;
  }
  .flex {
    display: flex;
    align-items: center;
    gap: 30px;
  }
  .flex-btn {
    .md-icon {
      color: $default-light-white;
    }
    .md-icon-font {
      color: $default-black !important;
    }
  }
  .grey {
    background-color: $gray_asset;
  }
</style>



// WEBPACK FOOTER //
// src/vue/app/history/index/History.Index.vue